import {
  IconApproval,
  IconCancel,
  IconError,
  IconPending,
} from '@moneyforward/ap-frontend-components';
import type { ApprovingReportStatus } from 'ap-openapi';
import { useMemo } from 'react';

export const useStatusIcon = (status: ApprovingReportStatus | undefined) => {
  return useMemo(() => {
    if (!status?.key) {
      return undefined;
    }

    switch (status.key) {
      case 'approved':
        return <IconApproval size={12} />;
      case 'rejected':
        return <IconError size={12} />;
      case 'canceled':
        return <IconCancel size={12} />;
      case 'waiting_step_one':
      case 'waiting_step_two':
      case 'waiting_step_three':
      case 'waiting_step_four':
      case 'waiting_step_five':
      case 'waiting_step_six':
      case 'waiting_step_seven':
      case 'waiting_step_eight':
      case 'waiting_step_nine':
      case 'waiting_step_ten':
        return <IconPending size={12} />;

      default:
        return <IconPending size={12} />;
    }
  }, [status?.key]);
};
